import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { QSelectItem } from '@qualio/ui-components';

import { useTags } from './useTags';

export const useTagOptions = () => {
  const { t } = useTranslation();
  const { data: tags = [], isLoading } = useTags();

  const options = useMemo<QSelectItem<string, number>[]>(
    () =>
      tags.map((tag) => ({
        value: tag.id,
        label: tag.name,
        ...(Boolean(tag.group_ids?.length) && {
          rightIcon: {
            iconName: 'Lock' as const,
            tooltip: t('template.properties.privateTag'),
            'data-cy': `private-tag-icon-${tag.name}`,
          },
        }),
      })),
    [tags, t],
  );

  return { options, isLoading };
};

export const filterTagOption = (option: { data: QSelectItem<string, number> }, searchTerm: string): boolean =>
  !searchTerm || option.data.label.toLowerCase().includes(searchTerm.toLowerCase());
